import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResultInfo } from '@interserve/angular'
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Actuate, ActuateGroupRelation } from '../../interfaces/backend.interface'

@Injectable({
  providedIn: 'root',
})
export class BackendApiService {
  constructor(private http: HttpClient) {}

  /**
   * アカウント情報を取得
   * @param token トークン
   * @returns アカウント情報
   */
  getAccountInfo(
    token: string,
    smTradeGarage: boolean = false
  ): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    let url = '';
    // 貿易部GarageのAPIを使用する場合
    if (smTradeGarage) {
      url = `${environment.smTradeGarageApiUrl}/v1.0/currentUser`;
      return this.http.get<any>(url, { headers });
    }
    // 通常のバックエンドマクロAPIを使用する場合
    else {
      url = `${environment.backendMacroApiUrl}/v3/Accounts/BackendLogin/Token`;
      return this.http.post<any>(url, {}, { headers });
    }
  }

  /**
   * 紐づけ設定の変更アラート値を取得する (今は使っていない、改修予定)
   * @param groupId グループID(ReporterId)
   * @returns true:アラートあり、false:アラートなし
   */
  getAlertStatus(groupId: string): Observable<boolean> {
    let url = `${environment.applicationActuateMacroApiUrl}/ActuateGroups/GroupIds/${groupId}/InventorySettingAlert`;
    return this.http.get<boolean>(url, {});
  }
}
